import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=974b2f8c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('974b2f8c')) {
      api.createRecord('974b2f8c', component.options)
    } else {
      api.reload('974b2f8c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=974b2f8c&", function () {
      api.rerender('974b2f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UENxzTYrWS7Q/JS/pricehelp.vue"
export default component.exports